import NumberVerification from './NumberVerification';

export default NumberVerification;
